module.exports = __webpack_public_path__ + "static/media/8.1b668a79.jpg";